import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";

import FilePreview from "../../../../../../common/filePreview";
import { PreviewContainer } from "../../styled/setting";

const Preview = ({ company }) => {
  return (
    <PreviewContainer>
      <div className="company">
        {company?.cmpnyImage && company?.cmpnyImage.length > 0 ? (
          <Swiper
            className="mySwiper"
            // ref={swiperRef}
            loop
            modules={[Pagination]}
            pagination={{ clickable: true }}>
            {(company?.cmpnyImage || []).map((item) => (
              <SwiperSlide key={item.id}>
                <div className="box">
                  <FilePreview item={item} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <img src="/img/shop_main_bg3.jpg" />
        )}
        <p>{company?.cmpnyNm}</p>
      </div>
      <div className="tags">
        {company?.cmpnySe && <strong>{company.cmpnySe}</strong>}
        {(company?.cmpnyBadgeText || []).map((badge) => (
          <span className="badge" key={badge.badgeName}>
            {badge}
          </span>
        ))}
      </div>
    </PreviewContainer>
  );
};

export default Preview;
